export { Lightbox } from './index.pc'
export { MobileLightbox } from './index.mobile'
